import React from "react";
import { Helmet } from "react-helmet-async";

import CustomerSlider from "./CustomerSlider";
import Hero from "./Hero";
import QuoteSection from "./QuoteSection";
import TestimonialCarousel from "./Testimonial";
import SEOContent from "./SEOContent"; // <-- NEW import

const Homepage = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ClothingStore",
    "name": "Dheeram Apparel Creations",
    "url": "https://dheeramapparel.com/",
    "logo": "https://dheeramapparel.com/logo.png",
    "image": "https://dheeramapparel.com/cover-image.jpg",
    "description":
      "Corporate uniforms & workwear manufacturer based in Chennai with a unit in Tiruppur. We create branded corporate clothing, industrial workwear, and promotional apparel.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "4/176, Andal Nagar Main road, Alapakkam",
      "addressLocality": "Chennai",
      "addressRegion": "Tamil Nadu",
      "postalCode": "600116",
      "addressCountry": "India"
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61577211818549",
      "https://www.instagram.com/dheeram.apparel.creations/",
      "https://www.linkedin.com/in/dheeram-apparel-creations-3821a8384/"
    ]
  };

  return (
    <>
      <Helmet>
        <title>
          Dheeram Apparel Creations
        </title>
        <meta
          name="description"
          content="Leading corporate uniforms & industrial workwear manufacturer in Chennai & Tiruppur. Custom t-shirts, safety wear, hospitality uniforms & promotional apparel."
        />
        <meta
          name="keywords"
          content="corporate uniforms, industrial workwear, custom t-shirts, hospitality uniforms, safety wear, promotional apparel, Chennai, Tiruppur"
        />
        <link rel="canonical" href="https://dheeramapparel.com/" />

      
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dheeramapparel.com/" />
        <meta
          property="og:title"
          content="Dheeram Apparel Creations"
        />
        <meta
          property="og:description"
          content="We combine comfort, style and durability in corporate uniforms and industrial workwear."
        />
        <meta
          property="og:image"
          content="https://dheeramapparel.com/cover-image.jpg"
        />

      
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://dheeramapparel.com/" />
        <meta
          name="twitter:title"
          content="Dheeram Apparel Creations"
        />
        <meta
          name="twitter:description"
          content="Leading corporate uniforms & industrial workwear manufacturer in Chennai & Tiruppur."
        />
        <meta
          name="twitter:image"
          content="https://dheeramapparel.com/cover-image.jpg"
        />

        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

     
      <div className="flex flex-col md:flex-row w-full min-h-screen bg-[#F6AE1B] transition-all sm:mt-10 duration-300 xl:mt-0">
        <div className="flex flex-col flex-1 w-full overflow-x-hidden">
          <Hero />

          <div className="flex items-center justify-center my-5">
            <div className="border-t border-black w-1/4"></div>
            <span className="mx-4 text-white text-xl">★</span>
            <div className="border-t border-black w-1/4"></div>
          </div>

          <QuoteSection />

          <div className="flex items-center justify-center my-4 mb-12">
            <div className="border-t border-black w-1/4"></div>
            <span className="mx-4 text-white text-xl">★</span>
            <div className="border-t border-black w-1/4"></div>
          </div>

          <SEOContent />

          <div className="flex items-center justify-center my-6">
            <div className="border-t border-black w-1/4"></div>
            <span className="mx-4 text-white text-xl">★</span>
            <div className="border-t border-black w-1/4"></div>
          </div>

          <TestimonialCarousel />
          <CustomerSlider />
        </div>
      </div>
    </>
  );
};

export default Homepage;
